// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2llCm","col":"CardReaderDesc_col__kcLV3","label":"CardReaderDesc_label__2TvV_"};